import * as Yup from 'yup'
import { toEnglishDigits } from 'utilities/helper/toEnglishNumber'

export const initialValues = {
    issuerIdCode: '',
    issuerName: '',
    issuerIban: '',
    issuerIdType: '1',
    issuerPostalCode: '',
    issuerAddress: '',
    issuerMobile: '',
    receiverName: '',
    receiverIdCode: '',
    receiverIdType: '2',
    receiverMobile: '',
    paymentPlace: '',
    amount: '',
    duDate: '',
    description: '',
    transferable: true,
}

export const validateStep = (values: any, step: number) => {
    const errors: any = {}
    const stepFields =
        {
            0: [
                'issuerIdCode',
                'issuerName',
                'issuerIban',
                'issuerIdType',
                'issuerPostalCode',
                'issuerAddress',
                'issuerMobile',
            ],
            1: [
                'receiverName',
                'receiverIdCode',
                'receiverIdType',
                'receiverMobile',
            ],
            2: ['amount', 'duDate', 'description', 'paymentPlace'],
        }[step] || []

    stepFields.forEach((field: string) => {
        if (!values[field]) {
            errors[field] = 'این فیلد اجباری است'
        } else {
            switch (field) {
                case 'issuerPostalCode':
                    if (!/^\d+$/.test(values[field])) {
                        errors[field] = 'این فیلد باید فقط شامل اعداد باشد'
                        values[field] = ''
                    }
                    break
                case 'issuerIban':
                    if (!/^IR\d{24}$/.test(values[field])) {
                        errors[field] =
                            'شماره شبا باید با IR شروع شده و شامل 24 رقم باشد'
                        values[field] = ''
                    }
                    break
                case 'receiverMobile':
                case 'issuerMobile':
                    if (!/^09\d{9}$/.test(values[field])) {
                        errors[field] =
                            'شماره موبایل باید با ۰۹ شروع شود و شامل ۱۱ رقم باشد'
                        values[field] = ''
                    }
                    break
                case 'issuerName':
                case 'receiverName':
                case 'issuerAddress':
                case 'description':
                    if (!/^[\u0600-\u06FF\s]+$/.test(values[field])) {
                        errors[field] = 'این فیلد باید فقط شامل حروف فارسی باشد'
                        values[field] = ''
                    }
                    break
                case 'issuerIdCode':
                case 'receiverIdCode':
                    if (!/^\d{10}$/.test(values[field])) {
                        errors[field] = 'این فیلد باید شامل ۱۰ رقم باشد'
                        values[field] = ''
                    }
                    break
                case 'amount':
                    if (!/^\d{8}/.test(values[field].replace(/,/g, ''))) {
                        errors[field] =
                            'مبلغ هر سفته حداقل ۲۰,۰۰۰,۰۰۰ ریال میباشد'
                        values[field] = ''
                    }
                    break
                default:
                    break
            }
        }
    })

    return errors
}

/**
 * Kept as a named re-export so the promissory handlers keep reading the way
 * they always did; the fold itself is shared now, and so this one finally
 * covers Arabic-Indic «٠-٩» too — the digits an Arabic keyboard layout, which
 * plenty of phones sold here ship with, actually emits.
 */
export const persianToEnglishDigits = toEnglishDigits

export const formatNumberWithCommas = (value: string) => {
    value = persianToEnglishDigits(value).replace(/[^0-9]/g, '')
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const processNumericInput = (
    value: string,
    setFieldValue: (
        field: string,
        value: any,
        shouldValidate?: boolean
    ) => void,
    maxLength: number,
    nameField: string
) => {
    value = persianToEnglishDigits(value)
    if (value.length > maxLength) {
        value = value.slice(0, maxLength)
    }
    setFieldValue(nameField, value)
}

export const cleanCommaField = (data) => {
    const cleanedData = { ...data }
    if (cleanedData.amount) {
        cleanedData.amount = cleanedData.amount.replace(/,/g, '')
    }
    return cleanedData
}

export const handleDateChange = (date, setFieldValue) => {
    const formattedDate = date ? date.format('YYYYMMDD') : ''
    const englishDate = persianToEnglishDigits(formattedDate.toString())
    setFieldValue('duDate', englishDate)
}
